const timingsKeys = {
    timingSlots: ['timing_slots'],
};

export default timingsKeys;
